import {
  makeStyles,
  Snackbar,
  SnackbarContent,
  Theme,
  Tooltip,
} from "@material-ui/core";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { Dispatch, StoreState } from "../store";
import { ErrorState } from "../types";

const useStyles = makeStyles((theme: Theme) => ({
  error: {
    backgroundColor: theme.palette.error.dark,
  },
}));

const ErrorSnackbar: React.FC = () => {
  const classes = useStyles();
  const dispatch = useDispatch<Dispatch>();
  const errors = useSelector<StoreState>(
    (state) => state.errors.errors
  ) as ErrorState["errors"];

  return (
    <Snackbar
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      onClose={() => dispatch.errors.reset()}
      open={!!errors.length}
    >
      <SnackbarContent
        className={classes.error}
        message={
          <>
            <h3>Errors</h3>
            {errors.map((error) => (
              <>
                <Tooltip title={error.stack ?? error.message}>
                  <span key={error.uuid}>{error.path}</span>
                </Tooltip>
                <br />
              </>
            ))}
          </>
        }
      />
    </Snackbar>
  );
};

export default ErrorSnackbar;



// WEBPACK FOOTER //
// ./src/components/ErrorSnackbar.tsx